import { apiRequest, HttpError } from '@shared/api'
import type {
    AutoLoginParams,
    LoginRequest,
    LoginResponse,
    VerifyOtpRequest,
} from '../types'
import { authApiRoutes } from './routes'

/** Auto-login via JSON body (replaces legacy query-string credentials). */
export function loginAuto(params: AutoLoginParams, signal?: AbortSignal): Promise<LoginResponse> {
    return apiRequest<LoginResponse>(authApiRoutes.loginAuto, {
        method: 'POST',
        data: params,
        signal,
    })
}

export function login(request: LoginRequest, signal?: AbortSignal): Promise<LoginResponse> {
    return apiRequest<LoginResponse>(authApiRoutes.login, {
        method: 'POST',
        data: request,
        signal,
    })
}
export function verifyOtp(request: VerifyOtpRequest, signal?: AbortSignal): Promise<LoginResponse> {
    return apiRequest<LoginResponse>(authApiRoutes.verifyOtp, {
        method: 'POST',
        data: request,
        signal,
    })
}

//-------- Change Password -------------

type ChangePasswordPayload = {
    userId: string;
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
};

type ApiResponse = {
    message: string;
};

export async function changePassword(
  data: ChangePasswordPayload,
  signal?: AbortSignal,
): Promise<string> {
  try {
    const result = await apiRequest<ApiResponse>('/api/auth/change-password', {
      method: 'POST',
      data: data,
      signal,
    })
    return result.message
  } catch (error) {
    if (error instanceof HttpError) {
      throw new Error(error.body || error.message)
    }
    throw error
  }
}
